import { render, staticRenderFns } from "./wtVoiceRecorderPackageWraper.vue?vue&type=template&id=5e5c9885&"
import script from "./wtVoiceRecorderPackageWraper.vue?vue&type=script&lang=js&"
export * from "./wtVoiceRecorderPackageWraper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports